import type { AuthProvider, AuthState } from './model.js';
import { parseRuntimeAuthConfig, type RuntimeConfigSource } from './config.js';
import { MsalBrowserClientAdapter } from './entra-client.js';
import { EntraAuthProvider } from './entra-provider.js';
import { MockEntraAuthProvider } from './mock-provider.js';

export function createRuntimeAuthProvider(source: RuntimeConfigSource): AuthProvider {
  try {
    const config = parseRuntimeAuthConfig(source);
    if (config.mode === 'MOCK') {
      return new MockEntraAuthProvider({ role: config.mockRole });
    }
    return new EntraAuthProvider(new MsalBrowserClientAdapter(config.entra), config.entra);
  } catch {
    return new ConfigurationErrorAuthProvider();
  }
}

class ConfigurationErrorAuthProvider implements AuthProvider {
  private readonly state: AuthState = {
    status: 'AUTHENTICATION_ERROR',
    message: 'Microsoft authentication is not configured for this environment.',
  };

  getState(): AuthState {
    return this.state;
  }

  subscribe(): () => void {
    return () => {};
  }

  async initialize(): Promise<void> {}
  async refreshSession(): Promise<void> {}
  async getIdentityToken(): Promise<string | null> { return null; }
  async signIn(): Promise<void> {}
  async signOut(): Promise<void> {}
}
